module.exports = __webpack_public_path__ + "img/stray-inventory.1096b9c2.jpg";